module.exports = __webpack_public_path__ + "img/KSC01687.a94c3eab.jpg";